import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-applicant-list-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './applicant-list-dialog.component.html',
  styleUrls: ['./applicant-list-dialog.component.scss']
})
export class ApplicantListDialogComponent implements OnInit {
  selectedFile: File | null = null;
  isFileUploaded = false;
  isEligibilityAutoDetermined: boolean = false;

  ngOnInit() {
    this.isEligibilityAutoDetermined = sessionStorage.getItem('isEligibilityAutoDetermined') === 'true';
  }
  constructor(
    private readonly dialogRef: MatDialogRef<ApplicantListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.isFileUploaded = false;
    }
  }

  clearFile() {
    this.selectedFile = null;
    this.isFileUploaded = false;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  uploadFile() {
    if (this.selectedFile) {
      // Close the dialog after uploading
      this.isFileUploaded = true;
    }
  }

  submit() {
    if (this.isFileUploaded) {
      // Close the dialog with the selected file
      this.dialogRef.close(this.selectedFile);
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}